import { createFileRoute, Navigate } from '@tanstack/react-router';
import { reportsSearchSchema } from 'src/modules/reports/schemas/reports-search.schema';
import { Route as CallsReportsRoute } from 'src/routes/calls.reports';

/**
 * Legacy reports route kept as a compatibility redirect.
 */
export const Route = createFileRoute('/reports/')({
  component: ReportsIndexComponent,
  validateSearch: (search) => reportsSearchSchema.parse(search),
});
function ReportsIndexComponent() {
  const search = Route.useSearch();

  return <Navigate to={CallsReportsRoute.to} search={search} replace />;
}
